import React from "react";
import CompanyDetailFields from "../CompanyDetailFields/CompanyDetailFields";
import { EntityType } from "@/services/hooks/entities/useEntityType";
import InvolvedIn from "@/components/layouts/InvolvedIn";
import Ownership from "@/components/layouts/Ownership";
import { CompanyData } from "@/pages/companies/types";
import { DetailedViewOptions } from "@/components/controls/OptionsDropdownMenu/OptionsDropdownMenu";
import CompanyKPIs from "@/pages/companies/components/CompanyKPIs";

interface Props {
  company: CompanyData | undefined;
  onUpdateField: (
    field: string,
    newValue: string | number,
    additionalFields?: {
      [fieldName: string]: string | number;
    },
    successToastText?: string,
    onSuccessFn?: () => void
  ) => void;
  getCreateOptions: () => DetailedViewOptions;
}

const CompanyOverviewContent: React.FC<Props> = ({
  company,
  onUpdateField,
  getCreateOptions
}) => {
  const createOptions = getCreateOptions();

  const getActionFunction = (option: any) => {
    return typeof option === "function" ? option : option?.action;
  };

  return (
    <div className="w-full flex flex-col gap-6">
      <CompanyKPIs company={company} />
      <div className="w-full flex gap-6">
        <div className="flex-1">
          <CompanyDetailFields
            company={company}
            onUpdateField={(
              field: string,
              newValue: string | number | string[]
            ) => onUpdateField(field, newValue as string | number)}
            containerClassName="grid-cols-[minmax(0,30%),1fr]"
          />
        </div>
        <div className="flex-1 flex flex-col gap-6">
          <InvolvedIn
            entityId={company?.id || ""}
            entityType={EntityType.COMPANY}
            onCreateLead={getActionFunction(createOptions.lead)}
            onCreateDeal={getActionFunction(createOptions.deal)}
            onCreateContract={getActionFunction(createOptions.contract)}
          />
          <Ownership
            entity={company}
            entityType={EntityType.COMPANY}
            onUpdateField={onUpdateField}
          />
        </div>
      </div>
    </div>
  );
};

export default CompanyOverviewContent;
